import type { Booking, Pitch, PitchCategory } from "@/types/camping";

export function pitchCodeForBooking(
  pitchId: string | null,
  pitches: Pick<Pitch, "id" | "code">[],
): string | null {
  if (!pitchId) return null;
  return pitches.find((x) => x.id === pitchId)?.code ?? pitchId.slice(0, 8);
}

export function pitchCategoryName(
  categoryId: string | null,
  categories: Pick<PitchCategory, "id" | "name">[],
): string {
  if (!categoryId) return "Ohne Kategorie";
  return categories.find((c) => c.id === categoryId)?.name ?? "—";
}

export function bookingPitchLabel(
  booking: Pick<Booking, "pitch_id" | "pitch_category_id">,
  pitches: Pick<Pitch, "id" | "code">[],
  categories: Pick<PitchCategory, "id" | "name">[],
): string {
  const code = pitchCodeForBooking(booking.pitch_id, pitches);
  if (code) return code;
  const cat = pitchCategoryName(booking.pitch_category_id, categories);
  return `Offen (${cat})`;
}

export function bookingPitchCodeOrOffen(
  booking: Pick<Booking, "pitch_id">,
  pitches: Pick<Pitch, "id" | "code">[],
): string {
  return pitchCodeForBooking(booking.pitch_id, pitches) ?? "Offen";
}
